import { createMintSocketBuilder } from '@mint-lib/api-zod-support/socket';
import { z } from 'zod';

export const socket = createMintSocketBuilder();

type OmniActionableEntity = {
  entityId: string;
  entityType: string;
  children: OmniActionableEntity[];
};

const actionableEntitySchema: z.ZodType<OmniActionableEntity> = z.object({
  entityId: z.string(),
  entityType: z.string(),
  children: z.array(z.lazy(() => actionableEntitySchema)),
});

export type ActionableEntity = z.infer<typeof actionableEntitySchema>;

const failedCampaignSchema = z.object({
  campaignId: z.string(),
  name: z.string(),
  platform: z.string().optional(),
  status: z.string().optional(),
  errors: z.array(z.string()).optional(),
});

export type FailedCampaign = z.infer<typeof failedCampaignSchema>;

const reimportEntitySchema = z.object({
  entityType: z.string(),
  id: z.string(),
  adGroupId: z.string().nullable(),
  campaignId: z.string().nullable(),
});

export type ReimportEntity = z.infer<typeof reimportEntitySchema>;

export const taskStatus = z.enum(['STARTED', 'FINISHED', 'REVOKED', 'none']);
export const taskType = z.enum(['IMPORT', 'SYNC', 'none']);

export const TaskStatus = taskStatus.enum;
export const TaskType = taskType.enum;

export type TaskStatusValue = z.infer<typeof taskStatus>;
export type TaskTypeValue = z.infer<typeof taskType>;

const taskStatusPayloadSchema = z.object({
  channel: z.string(),
  platform: z.string(),
  taskId: z.string(),
  taskStatus: taskStatus,
  taskType: taskType,
  actionableEntities: z.array(actionableEntitySchema),
  taskResult: z
    .object({
      errorResponses: z.array(failedCampaignSchema).optional(),
      reimportEntities: z.array(reimportEntitySchema).optional(),
      errors: z.array(z.string()).optional(),
    })
    .nullable()
    .optional(),
});

export type OmniTaskStatusPayload = z.infer<typeof taskStatusPayloadSchema>;

export const enterTileRoom = socket.defineSend({
  topic: 'enter_tile_room',
  payloadSchema: z.object({
    tileId: z.string(),
  }),
});

export const onTasksStatus = socket.defineSubscribe({
  topic: 'tasks_status',
  payloadSchema: z.array(taskStatusPayloadSchema),
});
